<template>
  <div id="tiny-search" class="container">
    <SimpleSearch/>
  </div>
</template>

<script>
  import SimpleSearch from './components/SimpleSearch'

  export default {
    name: 'tiny-search',
    components: {
      SimpleSearch
    }
  }
</script>

<style lang="stylus">
  @import "assets/variables.styl"
  pre
    padding 0.5rem 1rem
    background-color $default-color-light-1
</style>



// WEBPACK FOOTER //
// src/App.vue